import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import ProgramCategoryService from 'services/ProgramCategoryService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    data: []
}


export const addCategory = createAsyncThunk('programCategory/addCategory', async (data, { rejectWithValue }) => {
	
	try {
		const response = await ProgramCategoryService.addCategory(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const getCategory = createAsyncThunk('programCategory/getCategory', async (data, { rejectWithValue }) => {
	    
	try {
		const response = await ProgramCategoryService.getCategory(data)
		if (response.status) {
            
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const programCategorySlice = createSlice({
    name: 'programCategory',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(addCategory.pending, (state) => {
            state.loading = true
            state.message= ''
        })
        .addCase(addCategory.fulfilled, (state, action) => {
            state.loading = false
            state.data.unshift(action.payload);
            state.message = "Category Added"

        })
        .addCase(addCategory.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getCategory.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getCategory.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload
            state.message= ''
        })
        .addCase(getCategory.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
    }
});



export default programCategorySlice.reducer;